import { api } from "../utils/Axios";
import { toast } from "react-toastify";

const TOAST_OPTS = {
  position: "top-center",
  autoClose: 2000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

// ثابت واحد بدل إنشاء object ضخم كل مرة
const DEFAULT_PAYLOAD = Object.freeze({
  mobilePhone: "",
  email: "",
  name: "",
  homePhone: "",
  homeAddress: "",
  governance: "",
  area: "",
  carCondition: "",
  insuranceType: "",
  brand: "Brand",
  model: "",
  modelYear: "",
  buyerEmail: "",
  buyerName: "",
  buyerPhone: "",
  refName: "",
  refIdNo: "",
  refPhoneNumber: "",
  refProduct: "",
  needHelp: false,
  plan: "",
  category: "",
  refIdNumber: "",
  tenor: "0",
  amount: "0",
  downPayment: "0",
  installmentValue: "0",
  hrLetter: "",
  electricityBill: "",
  mortgageType: "",
  eCommerce: "",
  commercialTax: "",
  propertyGovern: "",
  businessName: "",
  noOfEmployees: "0",
  businessIndustry: "",
  companyName: "",
  siteLink: "",
  noOfBranches: "0",
  POS: "",
});

/**
 * Remove undefined/null keys so we don't overwrite defaults unintentionally
 */
function compact(obj) {
  if (!obj) return {};
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v !== undefined && v !== null) out[k] = v;
  }
  return out;
}

/**
 * Map CRM type -> payload.
 * Keeps logic centralized and avoids large switch side effects.
 */
function buildNewValues(type, values) {
  switch (String(type)) {
    case "25":
      return compact({
        companyName: values.company_name,
        name: values.specialist_name,
        mobilePhone: values.phoneNumber ? `+2${values.phoneNumber}` : undefined,
        mobile: values.phoneNumber ? `+2${values.phoneNumber}` : undefined,
        email: values.email,
        siteLink: values.url,
        noOfBranches: values.branch_number,
        homeAddress: values.address,
        governance: values.governorate,
        POS: values.POS,
        categories: values.categories,
        eCommerce: values.eCommerce,
        commercialTax: values.commercialTax,
      });

    case "26":
    case "27":
      return compact({
        businessName: values.business_name,
        name: values.person_name,
        mobilePhone: values.phoneNumber ? `+2${values.phoneNumber}` : undefined,
        mobile: values.phoneNumber ? `+2${values.phoneNumber}` : undefined,
        email: values.email,
        governance: values.governorate,
      });

    case "28":
      return compact({
        businessName: values.business_name,
        name: values.person_name,
        mobilePhone: values.phoneNumber ? `+2${values.phoneNumber}` : undefined,
        mobile: values.phoneNumber ? `+2${values.phoneNumber}` : undefined,
        email: values.email,
        noOfEmployees: values.employees_number,
      });

    // Placeholder: keep behavior (empty object)
    case "SavingInvestment":
      return {};

    default:
      return {};
  }
}

export const submitForm = async (type, values, actions, t) => {
  try {
    const newValues = buildNewValues(type, values);

    const payload = {
      crmId: type,
      ...DEFAULT_PAYLOAD,
      ...newValues,
      formSource: 28,
    };

    await api.post("/services/request-info", payload);

    toast.success(t.formMsg, TOAST_OPTS);
    actions?.resetForm?.();
  } catch (err) {
    const msg = err?.response?.data?.message;
    const errorMessage = Array.isArray(msg) ? msg[0] : msg;

    toast.error(errorMessage || t?.formMsgFail || "Something went wrong", TOAST_OPTS);
  }
};
